import React, { useEffect, useState } from 'react';

export default function PayPage() {
  const [status, setStatus] = useState('loading');
  const [error, setError]   = useState('');

  useEffect(() => {
    const params      = new URLSearchParams(window.location.search);
const vendorId    = params.get('vendorId');
const amount      = params.get('amount');
const eventName   = params.get('event') || 'Bio-EV Event';
const vendorEmail = params.get('vendorEmail') || '';
const vendorName  = params.get('vendorName') || '';

    if (!vendorId || !amount) {
      setStatus('error');
      setError('Missing payment information. Please contact Bio-EV.');
      return;
    }
    async function getToken() {
      try {
        const res  = await fetch('https://bioev-portal-production.up.railway.app/api/payments/create-pay-link', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ vendorId, amount, description: eventName, email: vendorEmail, returnUrl: `https://portal.bio-ev.com/payment/complete?vendorEmail=${encodeURIComponent(vendorEmail)}&vendorName=${encodeURIComponent(vendorName)}&amount=${amount}&eventName=${encodeURIComponent(eventName)}&vendorId=${vendorId}` }),
        });
        const data = await res.json();

        if (data.success) {
          // POST directly to Authorize.net with fresh token
          const form  = document.createElement('form');
          form.method = 'POST';
          form.action = data.payUrlBase;
          const input   = document.createElement('input');
input.type    = 'hidden';
input.name    = 'token';
input.value   = data.token;
form.appendChild(input);

const firstInput = document.createElement('input');
firstInput.type  = 'hidden';
firstInput.name  = 'billing_first_name';
firstInput.value = vendorName.split(' ')[0] || vendorName;
form.appendChild(firstInput);

const lastInput = document.createElement('input');
lastInput.type  = 'hidden';
lastInput.name  = 'billing_last_name';
lastInput.value = vendorName.split(' ').slice(1).join(' ') || '';
form.appendChild(lastInput);

document.body.appendChild(form);
form.submit();
        } else {
          setStatus('error');
          setError(data.errorText || 'Could not generate payment link.');
        }
      } catch (err) {
        setStatus('error');
        setError('Network error. Please try again or contact Bio-EV.');
      }
    }

    getToken();
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#040e1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ textAlign: 'center', padding: 40 }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#ffffff', marginBottom: 8 }}>Bio-EV</div>
        {status === 'loading' && <>
          <div style={{ fontSize: 14, color: '#5ae3a8', marginBottom: 20 }}>Preparing your secure payment page...</div>
          <div style={{ width: 40, height: 40, border: '3px solid #0a3d22', borderTop: '3px solid #5ae3a8', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </>}
        {status === 'error' && <div style={{ fontSize: 14, color: '#e37e7e', marginTop: 12 }}>{error}</div>}
      </div>
    </div>
  );
}